import { CROSS_SELL_TYPES } from 'apps/rails/src/pages/RIS/PnrStatus/Components/PNRCrossSells/types';
import { COMMON_PDT_CONSTANTS } from '../CommonPdtConstants';

export const RIS_EVENT_VALUES = {
  PNR_PAGE_RENDERED: 'pnr-page-rendered',
  RUTURN_TICKETS: CROSS_SELL_TYPES.RETURN_TICKETS,
  BUS_TICKETS: CROSS_SELL_TYPES.BUS,
  CONFIRMED_OPTIONS: CROSS_SELL_TYPES.CONFIRMED_OPTIONS,
};

export const pnrPdtEvents = (eventValue: string) => {
  let eventDetail = {};
  switch (eventValue) {
    case RIS_EVENT_VALUES.PNR_PAGE_RENDERED:
      eventDetail = {
        event_name: 'page-rendered',
        event_type: COMMON_PDT_CONSTANTS.LIFE_CYCLE_EVENT,
        event_value: RIS_EVENT_VALUES.PNR_PAGE_RENDERED,
      };
      break;
    case RIS_EVENT_VALUES.RUTURN_TICKETS:
      eventDetail = {
        event_name: COMMON_PDT_CONSTANTS.PRODUCT_CLICKED_EVENT,
        event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
        event_value: RIS_EVENT_VALUES.RUTURN_TICKETS,
      };
      break;
    case RIS_EVENT_VALUES.BUS_TICKETS:
      eventDetail = {
        event_name: COMMON_PDT_CONSTANTS.PRODUCT_CLICKED_EVENT,
        event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
        event_value: RIS_EVENT_VALUES.BUS_TICKETS,
      };
      break;
    case RIS_EVENT_VALUES.CONFIRMED_OPTIONS:
      eventDetail = {
        event_name: COMMON_PDT_CONSTANTS.PRODUCT_CLICKED_EVENT,
        event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
        event_value: RIS_EVENT_VALUES.CONFIRMED_OPTIONS,
      };
      break;
    default:
      eventDetail = {
        event_name: COMMON_PDT_CONSTANTS.CONTENT_CTA_CLICKED,
        event_type: COMMON_PDT_CONSTANTS.ACTION_EVENT,
        event_value: eventValue,
      };
      break;
  }
  return eventDetail;
};
